//services
import _ from 'lodash';
//reducers
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { getMessage, setMessage } from 'state/reducers/beneficiary.reducers';
//components
import { FormsStack } from 'theme/elements/Forms';
import { InfoCard } from 'theme/elements/Cards';
import { FormHeader1 } from 'theme/elements/Headers';
import { Paragraph1 } from 'theme/elements/Paragraphs';
import WarningDialog from 'components/WarningDialog';
//sections
//mui
import { Button } from '@mui/material';
//constants
import { Fragment, useMemo } from 'react';
import { timing, userMessage } from 'constants/ui.constants';
import { getCurrentConversionResponse, toggleUpserting } from 'state/reducers/convert.reducers';
import { ConversionResponse } from 'constants/convert.constants';
import { format, isValid } from 'date-fns';
import { FormButton } from 'theme/elements/Buttons';
import { useNavigate } from 'react-router-dom';

export default function Step3(props: { handleCancel: any }) {
  const userMessage: userMessage = useAppSelector(getMessage);
  const prefixFields = 'page.convert.create.step.3.';
  const dispatch = useAppDispatch();
  const t = useAppSelector(selectTranslations);
  const conversionResult: ConversionResponse = useAppSelector(getCurrentConversionResponse);
  const navigate = useNavigate();

  const openDialog = useMemo(() => {
    return userMessage.exist;
  }, [userMessage]);
  const getContact = useMemo(() => {
    if (_.has(conversionResult, 'pendingQuote.contact')) {
      return (
        _.get(conversionResult, 'pendingQuote.contact.firstName') +
        ' ' +
        _.get(conversionResult, 'pendingQuote.contact.lastName')
      );
    }
    return undefined;
  }, [conversionResult]);
  return (
    <Fragment>
      <WarningDialog
        open={openDialog}
        title={t(userMessage.text || '')}
        subTitle={userMessage.subText}
        handleCancel={() => {
          dispatch(setMessage({ exist: false }));
        }}
      />
      <FormsStack>
        <InfoCard>
          <FormHeader1 title={t(prefixFields + 'conversion_completed.title')} />
          <Paragraph1
            title={t(prefixFields + 'created_date.text')}
            text={
              isValid(new Date(_.get(conversionResult, 'createdAt') || 0))
                ? format(new Date(_.get(conversionResult, 'createdAt') || 0), timing.DATE)
                : _.get(conversionResult, 'createdAt')
            }
          />
          <Paragraph1
            title={t(prefixFields + 'settlement_date.text')}
            text={
              isValid(new Date(_.get(conversionResult, 'pendingQuote.dueDate') || 0))
                ? format(new Date(_.get(conversionResult, 'pendingQuote.dueDate') || 0), timing.DATE)
                : _.get(conversionResult, 'pendingQuote.dueDate')
            }
          />
          <Paragraph1
            title={t(prefixFields + 'sold.text')}
            text={
              String(_.get(conversionResult, 'pendingQuote.altshulerSellAmount', '')?.toLocaleString()) +
              ' ' +
              conversionResult.pendingQuote.clientSellCurrency
            }
          />
          <Paragraph1
            title={t(prefixFields + 'bought.text')}
            text={
              String(_.get(conversionResult, 'pendingQuote.altshulerBuyAmount', '')?.toLocaleString()) +
              ' ' +
              conversionResult.pendingQuote.clientBuyCurrency
            }
          />
          <Paragraph1
            title={t(prefixFields + 'final_rate.text')}
            text={
              !_.isNil(_.get(conversionResult, 'pendingQuote.altshulerRate'))
                ? _.get(conversionResult, 'pendingQuote.altshulerRate')
                : 0
            }
          />
          {!_.isEmpty(conversionResult.status) ? (
            <Paragraph1
              title={t(prefixFields + 'status.text')}
              text={t(prefixFields + 'status.' + _.snakeCase(String(conversionResult.status)) + '.text')}
            />
          ) : (
            <></>
          )}
          <Paragraph1
            title={t(prefixFields + 'reference.text')}
            text={_.get(conversionResult, 'reference')}
          />
          {getContact ? (
            <Paragraph1 title={t(prefixFields + 'created_by.text')} text={getContact || ''} />
          ) : (
            <></>
          )}
        </InfoCard>
        <FormButton>
          <Button
            className="singleFormButton"
            variant="contained"
            onClick={() => {
              dispatch(toggleUpserting(false));
            }}
          >
            {t(`${prefixFields}done_button.text`)}
          </Button>
        </FormButton>
      </FormsStack>
    </Fragment>
  );
}
